<!-- 充值管理 -->
<template>
  <div class="content">
    <div class="bodycontent">
      <div class="options">
        <el-form :model="params" label-width="80px" size="small">
          <div>
            <el-form-item class="options_item2" label="操作时间">
              <el-radio-group
                v-model="params.time"
                size="small"
                style="vertical-align: top;margin-right:15px"
                @change="changeTime"
              >
                <el-radio-button label="0">全部</el-radio-button>
                <el-radio-button label="1">今天</el-radio-button>
                <el-radio-button label="2">昨天</el-radio-button>
                <el-radio-button label="7">最近7天</el-radio-button>
                <el-radio-button label="30">最近30天</el-radio-button>
                <el-radio-button label="m">本月</el-radio-button>
                <!-- <el-radio-button label="y">本年</el-radio-button> -->
                <el-radio-button label="z">自定义</el-radio-button>
                <!-- <el-radio-button v-for="item in paymentOptions" :key="item.value" :label="item.value">{{item.name}}</el-radio-button> -->
              </el-radio-group>
              <el-date-picker
                v-model="dateValue[0]"
                type="date"
                class="date_picker_box"
                placeholder="开始日期"
                value-format="yyyy-MM-dd"
                :disabled="params.time != 'z'"
              ></el-date-picker>
              <el-time-picker
                placeholder="时间"
                v-model="timeValue[0]"
                :disabled="params.time != 'z'"
                class="time_picker_box"
                format="HH:mm"
                value-format="HH:mm"
                arrow-control
              ></el-time-picker>
              <span style="margin-right:8px">至</span>
              <el-date-picker
                v-model="dateValue[1]"
                type="date"
                class="date_picker_box"
                placeholder="结束日期"
                value-format="yyyy-MM-dd"
                :disabled="params.time != 'z'"
              ></el-date-picker>
              <el-time-picker
                placeholder="时间"
                v-model="timeValue[1]"
                class="time_picker_box"
                :disabled="params.time != 'z'"
                format="HH:mm"
                value-format="HH:mm"
                arrow-control
              ></el-time-picker>
              <el-button
                size="small"
                type="primary"
                v-show="params.time == 'z'"
                @click="timeSearch('search')"
                >搜索</el-button
              >
            </el-form-item>
            <el-form-item label="支付方式" class="options_item3">
              <el-radio-group
                v-model="params.payment_code"
                size="small"
                @change="getData(1)"
              >
                <el-radio-button label="0">全部</el-radio-button>
                <el-radio-button label="unionpay">银联支付</el-radio-button>
                <el-radio-button label="cash">现金支付</el-radio-button>
                <el-radio-button label="pos">pos终端</el-radio-button>
                <!-- <el-radio-button v-for="item in paymentOptions" :key="item.value" :label="item.value">{{item.name}}</el-radio-button> -->
              </el-radio-group>
            </el-form-item>
          </div>
          <el-form-item class="options_item" label="会员卡号" v-if="uid == ''">
            <el-input
              v-model="params.card_num"
              class="options_input"
              size="small"
            ></el-input>
          </el-form-item>
          <el-form-item class="options_item" label="手机号">
            <el-input
              v-model="params.mobile"
              class="options_input"
              size="small"
            ></el-input>
          </el-form-item>
          <el-form-item class="options_item" label="订单号">
            <el-input
              v-model="params.ordersn"
              class="options_input"
              size="small"
            ></el-input>
          </el-form-item>
          <el-form-item class="options_item" label="会员等级">
            <el-select
              v-model="params.user_level_id"
              placeholder="请选择"
              class="options_input"
              size="small"
              clearable
            >
              <el-option
                v-for="item in level_options"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="options_item" label="充值金额">
            <el-input
              v-model="params.money"
              class="options_input"
              size="small"
              style="vertical-align: middle;"
            >
              <el-select
                v-model="params.moneyType"
                slot="prepend"
                placeholder="请选择"
                style="width:98px;"
              >
                <el-option label="大于" value=">"></el-option>
                <el-option label="小于" value="<"></el-option>
                <el-option label="等于" value="="></el-option>
                <el-option label="大于等于" value=">="></el-option>
                <el-option label="小于等于" value="<="></el-option>
              </el-select>
            </el-input>
          </el-form-item>
          <div>
            <el-form-item class="options_item" label="店铺" v-if="uid == ''">
              <el-select
                v-model="params.room_id"
                placeholder="请选择"
                class="options_input"
                size="small"
                clearable
              >
                <el-option
                  v-for="item in store_options"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="options_item" label="操作员" v-if="uid == ''">
              <el-select
                v-model="params.emp_id"
                placeholder="请选择"
                class="options_input"
                size="small"
                clearable
              >
                <el-option
                  v-for="item in emp_options"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="options_item" label="来源" v-if="uid == ''">
              <el-select
                v-model="params.source"
                placeholder="请选择"
                class="options_input"
                size="small"
                clearable
              >
                <el-option
                  v-for="item in from_options"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="options_item" label="充值卡项">
              <el-cascader
                v-model="params.card_select"
                :options="typeCardList"
                class="options_input"
                size="small"
                clearable
                :props="{ expandTrigger: 'hover' }"
              ></el-cascader>
            </el-form-item>
            <el-form-item class="options_item" label="是否首充">
              <el-select
                v-model="params.is_first"
                placeholder="请选择"
                class="options_input"
                size="small"
                clearable
                @change="getData(1)"
              >
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="0"></el-option>
              </el-select>
            </el-form-item>
          </div>
        </el-form>
        <div style="margin-left:80px;margin-bottom:15px;" v-if="isvoucher != 1">
          <el-button type="primary" size="small" @click="search()"
            >查询</el-button
          >
          <!--          <el-button size="small" @click="clearAll()">清空</el-button>-->
          <!--          <el-button size="small">打印</el-button>-->
          <el-button size="small" @click="exportList()">导出</el-button>
          <el-button size="small" @click="batchDetele(2)">批量删除</el-button>
          <el-button size="small" @click="batchDetele(3)">时间段删除</el-button>
          <el-checkbox
            v-model="showAllList"
            style="margin-left: 15px;"
            @change="getData(1)"
            >显示未支付订单</el-checkbox
          >
          <el-checkbox
            v-model="showNewuser"
            style="margin-left: 15px;"
            @change="getData(1)"
            >显示今日新用户</el-checkbox
          >
        </div>
        <div v-else style="margin-left:80px;margin-bottom:15px;">
          <el-button type="primary" size="small" @click="search()"
            >查询</el-button
          >
          <el-button size="small" @click="recoverRecharge(2)"
            >批量恢复</el-button
          >
          <el-button size="small" @click="recoverRecharge(3)"
            >时间段恢复</el-button
          >
          <el-checkbox
            v-model="showAllList"
            style="margin-left: 15px;"
            @change="getData(1)"
            >显示未支付订单</el-checkbox
          >
        </div>
      </div>
      <div class="stat_box">
        <div class="stat_item_box">
          <div class="stat_item_title">充值单数</div>
          <div class="stat_item_value">
            {{ total }}
            <span>单</span>
          </div>
        </div>
        <!-- <div class="stat_item_box" v-if="false">
          <div class="stat_item_title">充值人数</div>
          <div class="stat_item_value">
            {{total}}
            <span>人</span>
          </div>
        </div>-->
        <div class="stat_item_box2">
          <div class="stat_item_title">充值总金额</div>
          <div class="stat_item_value2">
            <div>
              <div class="value2_title">实收金额</div>
              <div class="value2_value">
                {{ statItems.total_amount }}
                <span>元</span>
              </div>
            </div>
            <div>
              <div class="value2_title">手续费</div>
              <div class="value2_value">
                {{ statItems.total_fee }}
                <span>元</span>
              </div>
            </div>
            <div>
              <div class="value2_title">入账金额</div>
              <div class="value2_value">
                {{
                  (
                    Number(statItems.total_amount) - Number(statItems.total_fee)
                  ).toFixed(2)
                }}
                <span>元</span>
              </div>
            </div>
          </div>
        </div>
        <div class="stat_item_box">
          <div class="stat_item_title">赠送余额</div>
          <div class="stat_item_value">
            {{ statItems.balance }}
            <span>元</span>
          </div>
        </div>
        <div class="stat_item_box">
          <div class="stat_item_title">赠送积分</div>
          <div class="stat_item_value">
            {{ statItems.point }}
            <span>分</span>
          </div>
        </div>
        <!-- <div class="stat_item_box" v-if="false">
          <div class="stat_item_title">赠送优惠券</div>
          <div class="stat_item_value">
            {{total}}
            <span>张</span>
          </div>
        </div>-->
      </div>
      <div>
        <el-table
          :header-cell-style="setTableHeader"
          :data="listData"
          v-loading="tableLoading"
          element-loading-text="正在查询..."
          border
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="40" fixed></el-table-column>
          <el-table-column label="订单编号" prop="ordersn"></el-table-column>
          <el-table-column label="用户名称">
            <template slot-scope="scope">
              <div>
                <el-button
                  v-if="scope.row.user"
                  type="text"
                  @click="rowClick(scope.row.level.uid)"
                  >{{ scope.row.user.real_name }}</el-button
                >
              </div>
            </template>
          </el-table-column>
          <el-table-column label="手机号">
            <template slot-scope="scope">
              <div>
                <el-button
                  v-if="scope.row.user"
                  type="text"
                  @click="rowClick(scope.row.level.uid)"
                  >{{ scope.row.user.mobile }}</el-button
                >
              </div>
            </template>
          </el-table-column>

          <el-table-column label="充值金额" prop="amount"></el-table-column>
          <el-table-column label="赠送金额" prop="balance"></el-table-column>
          <el-table-column label="赠送积分" prop="point"></el-table-column>
          <el-table-column label="是否首充">
            <template slot-scope="scope">{{
              scope.row.is_first == 1 ? "是" : "否"
            }}</template>
          </el-table-column>
          <el-table-column label="状态">
            <template slot-scope="scope">
              <div>
                {{ scope.row.show_status }}
                <el-button
                  type="text"
                  style="padding:0"
                  v-if="scope.row.allow_pay == '1'"
                  @click="confirmOrderItem(scope.row.ordersn, 1)"
                  >确认</el-button
                >
                <el-button
                  type="text"
                  style="padding:0;color:#f56c6c"
                  v-if="scope.row.allow_pay == '1'"
                  @click="confirmOrderItem(scope.row.ordersn, 2)"
                  >取消</el-button
                >
              </div>
            </template>
          </el-table-column>
          <el-table-column label="充值卡项">
            <template slot-scope="scope">
              <div>
                {{
                  scope.row.type == 0
                    ? "会员卡"
                    : scope.row.type == 1
                    ? "加油卡"
                    : scope.row.type == 2
                    ? "车队卡"
                    : ""
                }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            label="支付方式"
            prop="show_payment"
          ></el-table-column>
          <el-table-column label="手续费" prop="fee"></el-table-column>
          <el-table-column label="入账金额">
            <template slot-scope="scope">
              <span>
                {{
                  (Number(scope.row.amount) - Number(scope.row.fee)).toFixed(2)
                }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="员工" prop="emp.name"> </el-table-column>
          <el-table-column
            label="操作人"
            prop="operator.mobile"
          ></el-table-column>
          <el-table-column
            label="下单时间"
            prop="create_time"
          ></el-table-column>
          <el-table-column label="备注" prop="message"></el-table-column>
          <el-table-column
            label="支付时间"
            prop="show_payTime"
          ></el-table-column>
          <el-table-column label="来源" prop="show_from"></el-table-column>
          <el-table-column label="操作" width="180px" fixed="right" align="center">
            <template slot-scope="scope">
              <div class="operation-buttons">
                <div
                  v-if="scope.row.pay_status != 1 && isvoucher != 1"
                  class="operation-btn"
                >
                  <el-button
                    type="text"
                    class="action-button action-button-warning"
                    @click="refundShow(scope.row)"
                  >
                    订单退款
                  </el-button>
                </div>
                <div
                  v-if="canOpenInvoice(scope.row) || canShowIssuedInvoice(scope.row)"
                  class="operation-btn"
                >
                  <el-button
                    v-if="canOpenInvoice(scope.row)"
                    type="text"
                    class="action-button action-button-primary"
                    @click="open_invoice(scope.row)"
                  >
                    开具发票
                  </el-button>
                  <el-button
                    v-else
                    type="text"
                    class="action-button action-button-info"
                    disabled
                  >
                    已开票
                  </el-button>
                </div>
                <div
                  v-if="scope.row.order_query == 1 && isvoucher != 1"
                  class="operation-btn"
                >
                  <el-button
                    type="text"
                    class="action-button action-button-info"
                    @click="Query_status(scope.row)"
                  >
                    状态查询
                  </el-button>
                </div>
                <div
                  v-if="scope.row.pay_status != 1 && isvoucher != 1"
                  class="operation-btn"
                >
                  <el-button
                    type="text"
                    class="action-button action-button-success"
                    @click="printReceipt(scope.row.id)"
                  >
                    打印小票
                  </el-button>
                </div>
                <div class="operation-btn">
                  <el-button
                    type="text"
                    class="action-button action-button-info"
                    @click="isMessage(scope.row)"
                  >
                    订单备注
                  </el-button>
                </div>
                <div v-if="isvoucher == 1" class="operation-btn">
                  <el-button
                    type="text"
                    class="action-button action-button-success"
                    @click="recoverRecharge(1, scope.row.id)"
                  >
                    恢复订单
                  </el-button>
                </div>
                <div v-if="isvoucher != 1" class="operation-btn">
                  <el-button
                    type="text"
                    class="action-button action-button-danger"
                    @click="batchDetele(1, scope.row.id)"
                  >
                    删除订单
                  </el-button>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 分页按钮 -->
      <div class="Otherpage">
        <el-pagination
          layout="prev, pager, next, total, jumper"
          :current-page="page"
          :total="total"
          :page-size="10"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>
    <!-- 确认订单 -->
    <el-dialog
      :visible.sync="showConfirmOrder"
      @close="showConfirmOrder = false"
      title="确认支付"
      width="400px"
    >
      <div class="align_c" style="margin-top:-15px">
        支付方式：
        <el-select
          size="small"
          v-model="confirmData.type"
          style="width:180px;margin-right:15px"
        >
          <el-option label="现金" value="cash"></el-option>
        </el-select>
        <el-button
          size="small"
          type="primary"
          :loading="submitLoading"
          @click="confirmOrderSubmit()"
          >确认</el-button
        >
      </div>
    </el-dialog>
    <!-- 取消订单 -->
    <el-dialog
      :visible.sync="showCancelOrder"
      @close="showCancelOrder = false"
      title="取消订单"
      width="400px"
    >
      <div style="margin-bottom:20px">订单号：{{ confirmData.ordersn }}</div>
      <div>
        <el-button
          style="width:100%"
          type="danger"
          size="samll"
          :loading="submitLoading"
          @click="cancelOrderSubmit()"
          >取消订单</el-button
        >
      </div>
      <!-- <div class="align_c" style="margin-top:15px"><el-button size="small" type="primary" @click="confirmOrderSubmit()">确认</el-button></div> -->
    </el-dialog>
    <!-- 批量删除 -->
    <el-dialog
      title="删除操作"
      :visible.sync="batchShow"
      @close="closeBatchPopup"
      width="700px"
    >
      <div
        v-if="deleteForm.is_verification"
        style="display:flex;margin-bottom: 10px;"
      >
        <!--  v-if="deleteForm.is_verification" -->
        <div>验证码：</div>
        <el-input v-model="deleteForm.code" style="width: 220px;">
          <template slot="append">
            <el-link :disabled="btn_status" @click="getCode" type="primary">{{
              code_text
            }}</el-link>
          </template>
        </el-input>
      </div>
      <div v-if="deleteForm.status == '3'">
        时间范围：
        <el-date-picker
          v-model="dateValueFake[0]"
          type="date"
          class="date_picker_delete"
          placeholder="开始日期"
          value-format="yyyy-MM-dd"
        ></el-date-picker>
        <el-time-picker
          placeholder="时间"
          v-model="dateValueFake[1]"
          class="date_picker_delete"
          format="HH:mm:ss"
          value-format="HH:mm:ss"
        ></el-time-picker>
        <span style="margin-right:8px">至</span>
        <el-date-picker
          v-model="timeValueFake[0]"
          type="date"
          class="date_picker_delete"
          placeholder="结束日期"
          value-format="yyyy-MM-dd"
        ></el-date-picker>
        <el-time-picker
          placeholder="时间"
          v-model="timeValueFake[1]"
          class="date_picker_delete"
          format="HH:mm:ss"
          value-format="HH:mm:ss"
        ></el-time-picker>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeBatchPopup">取 消</el-button>
        <el-button type="primary" @click="FakeRechangeOrder(1)"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="删除恢复"
      :visible.sync="batchShows"
      @close="closeBatchPopup"
      width="700px"
    >
      <div
        v-if="deleteForm.is_verification"
        style="display:flex;margin-bottom: 10px;"
      >
        <!--  v-if="deleteForm.is_verification" -->
        <div>验证码：</div>
        <el-input v-model="deleteForm.code" style="width: 220px;">
          <template slot="append">
            <el-link :disabled="btn_status" @click="getCode" type="primary">{{
              code_text
            }}</el-link>
          </template>
        </el-input>
      </div>
      <div v-if="deleteForm.status == '3'">
        时间范围：
        <el-date-picker
          v-model="dateValueFake[0]"
          type="date"
          class="date_picker_delete"
          placeholder="开始日期"
          value-format="yyyy-MM-dd"
        ></el-date-picker>
        <el-time-picker
          placeholder="时间"
          v-model="dateValueFake[1]"
          class="date_picker_delete"
          format="HH:mm:ss"
          value-format="HH:mm:ss"
        ></el-time-picker>
        <span style="margin-right:8px">至</span>
        <el-date-picker
          v-model="timeValueFake[0]"
          type="date"
          class="date_picker_delete"
          placeholder="结束日期"
          value-format="yyyy-MM-dd"
        ></el-date-picker>
        <el-time-picker
          placeholder="时间"
          v-model="timeValueFake[1]"
          class="date_picker_delete"
          format="HH:mm:ss"
          value-format="HH:mm:ss"
        ></el-time-picker>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeBatchPopup">取 消</el-button>
        <el-button type="primary" @click="FakeRechangeOrder(2)"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="退款操作"
      :visible.sync="refundIsShow"
      @close="closeRefund"
      width="700px"
    >
      <el-form label-width="auto">
        <div style="margin-bottom: 10px;">退款单号: {{ ordersn }}</div>
        <div style="margin-bottom: 10px;">退款金额: {{ money }}</div>

        <el-form-item label="退款原因">
          <el-input
            v-model="desc"
            placeholder="请输入退款原因"
            type="textarea"
            :rows="4"
          ></el-input>
        </el-form-item>
        <el-form-item label="验证码" v-if="config.open_refund_recharge == 1">
          <el-input
            v-model="verification_code"
            placeholder="请输入"
            style="width: 220px;"
          >
            <template slot="append">
              <el-link :disabled="btn_status" @click="getCode" type="primary">{{
                code_text
              }}</el-link>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="closeRefund">取 消</el-button>
          <el-button type="primary" @click="refundSubmit">确 定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog title="订单备注" :visible.sync="showMsg" width="700px">
      <el-form label-width="auto">
        <el-form-item label="备注">
          <el-input
            v-model="msg"
            placeholder="请输入"
            type="textarea"
            :rows="4"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="showMsg = false">取 消</el-button>
          <el-button type="primary" @click="Submit_msg">确 定</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog
      title="开具发票"
      :visible.sync="showInvoice"
      width="700px"
      @close="closeInvoice"
    >
      <el-form
        :model="invoiceForm"
        :rules="invoiceRules"
        ref="invoiceFormRef"
        label-width="110px"
      >
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="发票类型" prop="titleType">
              <el-select
                v-model="invoiceForm.titleType"
                placeholder="请选择发票类型"
                style="width: 100%;"
              >
                <el-option label="电子普通发票" value="1"></el-option>
                <el-option label="电子专用发票" value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="抬头类型" prop="type_person">
              <el-radio-group
                v-model="invoiceForm.type_person"
                @change="onTitleTypeChange"
              >
                <el-radio :label="1">个人</el-radio>
                <el-radio :label="2">企业</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="发票抬头" prop="buyerName">
          <el-input
            v-model="invoiceForm.buyerName"
            placeholder="请填写发票抬头"
          ></el-input>
        </el-form-item>
        <template v-if="invoiceForm.type_person === 2">
          <el-form-item label="纳税人识别号" prop="taxNo">
            <el-input
              v-model="invoiceForm.taxNo"
              placeholder="请填写纳税人识别号"
            ></el-input>
          </el-form-item>
          <el-form-item label="单位地址" prop="companyAddress">
            <el-input
              v-model="invoiceForm.companyAddress"
              placeholder="请填写单位地址"
            ></el-input>
          </el-form-item>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="公司电话" prop="companyTel">
                <el-input
                  v-model="invoiceForm.companyTel"
                  placeholder="请填写公司电话"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="开户银行" prop="bank">
                <el-input
                  v-model="invoiceForm.bank"
                  placeholder="请填写开户银行"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="银行账号" prop="account">
            <el-input
              v-model="invoiceForm.account"
              placeholder="请填写银行账号"
            ></el-input>
          </el-form-item>
        </template>
        <el-form-item label="邮箱" prop="email">
          <el-input
            v-model="invoiceForm.email"
            placeholder="请填写邮箱"
          ></el-input>
        </el-form-item>
        <el-form-item label="留言" prop="remark">
          <el-input
            v-model="invoiceForm.remark"
            type="textarea"
            :rows="3"
            placeholder="请填写留言"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="closeInvoice">取 消</el-button>
          <el-button
            type="primary"
            :loading="invoiceLoading"
            @click="submitInvoice"
          >
            确 定
          </el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import { storeSelect } from "@/api/employee";
import { message, open_invoiceNo } from "@/api/user";
import {
  cancelRecharge,
  confirmRecharge,
  deleteFakeRechangeOrder,
  employeeOptions,
  equipmentOptions,
  exportMethod,
  getTypeCardList,
  recharge_order_query,
  rechargePrint,
  refund_recharge,
  refund_status,
  vipList,
  voucherList,
  voucherSet,
  voucherSetList,
} from "@/api/vip";
import selectCommodity from "@/components/commodity/selectCommodity.vue";
import { mapGetters } from "vuex";
import {
  get_safeinfo,
  SendAdminCode,
  get_search_biz_user_id,
  getConfigButton
} from "@/api/set";
import { deleteRechargeList, recoverRecharge } from "@/api/order";

const createInvoiceForm = () => ({
  type: "",
  type_person: 1,
  titleType: "1",
  buyerName: "",
  taxNo: "",
  companyAddress: "",
  companyTel: "",
  bank: "",
  account: "",
  email: "",
  remark: ""
});

export default {
  computed: {
    ...mapGetters(["token", "app_id"]),
  },
  components: {
    selectCommodity,
  },
  props: {
    uid: {
      type: String,
      default: "",
    },
    isvoucher: {
      type: Number,
      default: 0,
    },
  },
  watch: {
    uid(val) {
      console.log(val);
      this.listData = [];
      this.getData();
    },
  },
  data() {
    return {
      showNewuser: false,
      desc: "",
      ordersn: "",
      money: "",
      verification_code: "",
      refundIsShow: false,
      deleteForm: {
        status: "", //1 为 单个删除 2，多个单订单 3， 时间批量
        id: "",
        code: "", //验证码
        is_verification: false,
      },
      code_text: "获取验证码",
      btn_status: false,
      timer: null,
      menus: "充值记录",
      listData: [], //充值记录列表
      discountList: [], //充值优惠列表
      start_time: "",
      end_time: "",
      keyword: "",
      page: 1,
      total: 0,
      showAdd: false,
      amount: "",
      formData: {}, //添加表单
      showSelecter: false, //优惠券选择器
      selected: [], //选择的优惠券
      sList: [], //已选择的优惠券列表
      giveList: [], //赠送内容列表
      typeList: [], //赠送类型列表
      showAllList: false, //是否显示未支付订单
      params: {
        card_num: "", //会员卡号
        ordersn: "", //订单编号
        user_level_id: "", //等级id
        room_id: "", //门店id
        emp_id: "", //员工id
        from_id: "", //来源
        money: "", //金额查询
        moneyType: ">", //充值金额 1.大于 2.小于 3.等于 4.大于等于 5.小于等于
        time: "0",
        payment_code: "0", // 支付方式
        source: "", // 来源
        card_select: [], // 充值卡项
      }, //查询参数
      level_options: [], //等级选择项
      store_options: [], //店铺选择项
      emp_options: [], //员工选择项
      tlPaysearchs: [], //通联会员
      from_options: [
        { id: "wx", name: "微信" },
        { id: "h5", name: "支付宝" },
        { id: "wxapp", name: "微信小程序" },
        { id: "aliapp", name: "支付宝小程序" },
        { id: "pos", name: "pos终端机" },
        { id: "pc", name: "后台" },
        { id: "ali", name: "支付宝" },
        { id: "fuiou", name: "闪付" },
      ], //来源选择项
      showConfirmOrder: false, //确认未支付订单弹窗
      showCancelOrder: false, // 取消未支付订单弹窗
      confirmData: {}, // 确认未支付订单信息
      dateValue: [], //消费时间
      timeValue: [],
      statItems: {}, // 统计项
      submitLoading: false, // 确认loading
      paymentOptions: [
        //支付方式选项
        { name: "微信支付", value: "wxpay" },
        { name: "余额支付", value: "balance" },
        { name: "支付宝免签", value: "single_alipay" },
        { name: "微信免签", value: "single_wxpay" },
        { name: "银联支付", value: "unionpay" },
      ],
      tableLoading: false, //表格loading
      pickerOptions: {
        //时间快捷选项
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      typeCardList: [
        {
          value: "0",
          label: "会员卡",
          children: [{ value: "0", label: "会员卡" }],
        },
        { value: "1", label: "加油卡", children: [] },
        { value: "2", label: "车队卡", children: [] },
      ], // 各类充值卡项
      multipleSelection: [], //表格多选
      dateValueFake: [], //消费时间
      timeValueFake: [],
      batchShow: false,
      batchShows: false,
      config: {},
      msg: "",
      showMsg: false,
      showInvoice: false,
      invoiceLoading: false,
      invoiceButtonVisible: true,
      invoiceForm: createInvoiceForm(),
      invoiceCurrentRow: null,
      invoiceRules: {
        titleType: [
          { required: true, message: "请选择发票类型", trigger: "change" }
        ],
        type_person: [
          { required: true, message: "请选择抬头类型", trigger: "change" }
        ],
        buyerName: [
          { required: true, message: "请填写发票抬头", trigger: "blur" }
        ],
        taxNo: [
          { required: true, message: "请填写纳税人识别号", trigger: "blur" }
        ],
        email: [
          { type: "email", message: "请填写正确的邮箱格式", trigger: "blur" }
        ]
      }
    };
  },
  mounted() {
    this.init();
    this.getInvoiceButtonConfig();
  },
  methods: {
    async Submit_msg() {
      const res = await message({
        app_id: this.app_id,
        ordersn: this.ordersn,
        message: this.msg,
      });
      if (res.code == 200) {
        this.$message.success("备注成功");
        (this.showMsg = false), (this.ordersn = "");
        this.getData(1);
      } else {
        this.$message.error(res.msg);
      }
    },
    isMessage(row) {
      this.showMsg = true;
      this.msg = row.message;
      this.ordersn = row.ordersn;
    },
    getInvoiceStatus(row) {
      if (!row || !row.invoice) return "";
      const invoice = row.invoice.data || row.invoice.info || row.invoice;
      if (invoice.status === undefined) return "";
      return String(invoice.status);
    },
    isInvoicePaymentSupported(row) {
      const paymentCode = String((row && row.payment_code) || "");
      return (
        paymentCode !== "balance" &&
        paymentCode !== "card_balance" &&
        paymentCode !== "family_balance" &&
        paymentCode !== "team_balance"
      );
    },
    parseInvoiceButtonStatus(res) {
      if (!res || res.code != 200) return true;
      const data = res.data;
      if (data === 0 || data === 1 || data === "0" || data === "1") {
        return Number(data) === 1;
      }
      if (
        data &&
        (data.status === 0 ||
          data.status === 1 ||
          data.status === "0" ||
          data.status === "1")
      ) {
        return Number(data.status) === 1;
      }
      if (data && Array.isArray(data.value) && data.value.length) {
        const item =
          data.value.find((n) => n.name === "invoice_button") || data.value[0];
        if (
          item &&
          (item.status === 0 ||
            item.status === 1 ||
            item.status === "0" ||
            item.status === "1")
        ) {
          return Number(item.status) === 1;
        }
      }
      return true;
    },
    getInvoiceButtonConfig() {
      getConfigButton({
        token: this.token,
        app_id: this.app_id,
        button_name: "invoice_button"
      })
        .then((res) => {
          this.invoiceButtonVisible = this.parseInvoiceButtonStatus(res);
        })
        .catch(() => {
          this.invoiceButtonVisible = true;
        });
    },
    canOpenInvoice(row) {
      const status = this.getInvoiceStatus(row);
      return (
        this.invoiceButtonVisible &&
        this.isInvoicePaymentSupported(row) &&
        row &&
        row.pay_status != 1 &&
        this.isvoucher != 1 &&
        (status === "" || status === "0")
      );
    },
    canShowIssuedInvoice(row) {
      const status = this.getInvoiceStatus(row);
      return (
        this.invoiceButtonVisible &&
        this.isInvoicePaymentSupported(row) &&
        row &&
        row.pay_status != 1 &&
        this.isvoucher != 1 &&
        status !== "" &&
        status !== "0"
      );
    },
    applyInvoiceToRow(row, form, status) {
      if (!row) return;
      row.invoice = {
        ...(row.invoice || {}),
        status: status === undefined ? 1 : status,
        titleType: form.titleType,
        title_type: form.titleType,
        type_person: form.type_person,
        buyerName: form.buyerName,
        buyer_name: form.buyerName,
        taxNo: form.taxNo,
        tax_no: form.taxNo,
        companyAddress: form.companyAddress,
        company_address: form.companyAddress,
        companyTel: form.companyTel,
        company_phone: form.companyTel,
        bank: form.bank,
        bank_name: form.bank,
        account: form.account,
        bank_account: form.account,
        email: form.email,
        remark: form.remark
      };
    },
    open_invoice(row) {
      this.invoiceCurrentRow = row;
      this.showInvoice = true;
      this.$nextTick(() => {
        this.$refs.invoiceFormRef && this.$refs.invoiceFormRef.clearValidate();
      });
    },
    closeInvoice() {
      this.showInvoice = false;
      this.invoiceForm = createInvoiceForm();
      this.invoiceCurrentRow = null;
      this.$refs.invoiceFormRef && this.$refs.invoiceFormRef.resetFields();
    },
    onTitleTypeChange(val) {
      if (val === 1) {
        this.invoiceForm.taxNo = "";
        this.invoiceForm.companyAddress = "";
        this.invoiceForm.companyTel = "";
        this.invoiceForm.bank = "";
        this.invoiceForm.account = "";
      }
    },
    submitInvoice() {
      this.$refs.invoiceFormRef.validate(async (valid) => {
        if (!valid) return;
        try {
          this.invoiceLoading = true;
          const res = await open_invoiceNo({
            app_id: this.invoiceCurrentRow.app_id,
            ordersn: this.invoiceCurrentRow.ordersn,
            ...this.invoiceForm,
            type: 2,
            reissue: 0
          });
          if (res.code === 200) {
            this.$message.success("发票开具成功");
            this.applyInvoiceToRow(this.invoiceCurrentRow, this.invoiceForm, 1);
            this.closeInvoice();
          } else {
            this.$message.error(res.msg || "发票开具失败");
          }
        } catch (error) {
          this.$message.error("发票开具失败");
          console.log(error);
        } finally {
          this.invoiceLoading = false;
        }
      });
    },
    //状态查询
    async Query_status(row) {
      const res = await recharge_order_query({
        app_id: this.app_id,
        ordersn: row.ordersn,
      });
      if (res.code == 200) {
        console.log("状态查询1", res);
        this.$message.success(res.msg);
      } else {
        this.$message.error(res.msg);
      }
    },
    init() {
      //初始化数据init
      // this.loading = true;
      var data = {
        token: this.token,
        app_id: this.app_id,
      };
      storeSelect(data).then((res) => {
        if (res.code == 200) {
          this.store_options = res.data;
          this.loading = false;
        } else {
          // this.$message({
          //   type: "error",
          //   message: "获取门店列表失败，请刷新重试"
          // })
        }
      });
      get_search_biz_user_id({ app_id: this.app_id }).then((res) => {
        if (res.code == 200) {
          console.log(res);
          this.tlPaysearchs = res.data.biz_user_ids;
        }
      });
      vipList(data).then((res) => {
        if (res.code == 200) {
          res.data.forEach((item) => {
            this.level_options.push({ id: item.id, name: item.name });
          });
        } else {
          // this.$message({
          //   type: "error",
          //   message: "获取会员等级列表失败，请刷新重试"
          // })
        }
      });
      employeeOptions(data).then((res) => {
        if (res.code == 200) {
          this.emp_options = res.data;
        } else {
          // this.$message({
          //   type: "error",
          //   message: "获取员工列表失败，请刷新重试"
          // })
        }
      });
      equipmentOptions(data).then((res) => {
        if (res.code == 200) {
          this.equ_options = res.data;
        } else {
          // this.$message({
          //   type: "error",
          //   message: "获取油枪列表失败，请刷新重试"
          // })
        }
      });
      voucherSetList(data).then((res) => {
        if (res.code == 200) {
          this.discountList = res.data;
        }
      });
      getTypeCardList(data).then((res) => {
        if (res.code == 200) {
          res.data.forEach((item) => {
            if (item.type == 1) {
              this.typeCardList[1].children.push({
                value: item.id,
                label: item.name,
              });
            } else if (item.type == 2) {
              this.typeCardList[2].children.push({
                value: item.id,
                label: item.name,
              });
            }
          });
          this.getData();
        }
      });
      this.typeList = [
        { id: "1", name: "积分" },
        { id: "2", name: "余额" },
        { id: "3", name: "优惠券" },
      ];
      this.get_detail();
    },
    // 根据tab页获取数据
    getData(i) {
      if (i) {
        this.page = i;
      }
      this.tableLoading = true;
      var data = {
        token: this.token,
        app_id: this.app_id,
        page: this.page,
        biz_user_ids: this.tlPaysearchs.join(","),
        new_user: Number(this.showNewuser),
        // card_num: this.params.card_num, //会员卡号
        // ordersn: this.params.ordersn, //订单编号
        user_level_id: this.params.user_level_id, //等级id
        // room_id: this.params.room_id, //门店id
        // emp_id: this.params.emp_id, //员工id
      };
      console.log(this.params);
      if (this.params.card_num != "") {
        data.card_num = this.params.card_num;
      }
      if (this.params.mobile != "") {
        data.mobile = this.params.mobile;
      }
      if (this.params.ordersn != "") {
        data.ordersn = this.params.ordersn;
      }
      if (this.params.emp_id != "") {
        data.emp_id = this.params.emp_id;
      }
      if (this.params.user_level_id != "") {
        data.user_level_id = this.params.user_level_id;
      }
      if (this.params.room_id != "") {
        data.room_id = this.params.room_id;
      }
      if (this.params.source != "") {
        data.source = this.params.source;
      }
      if (this.params.payment_code != "0") {
        data.payment_code = this.params.payment_code;
      }
      if (this.params.is_first) {
        data.is_first = this.params.is_first;
      }
      // if(this.dateValue !== null && this.dateValue.length !== 0){
      //   data.pay_start_time = this.dateValue[0]
      //   data.pay_end_time = this.dateValue[1]
      // }
      if (this.params.time != "0") {
        if (this.params.time == "1") {
          data.pay_start_time = this.formatTime(new Date(), 1);
          data.pay_end_time = this.formatTime(new Date(), 2);
        }
        if (this.params.time == "2") {
          var start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24);
          data.pay_start_time = this.formatTime(start, 1);
          data.pay_end_time = this.formatTime(start, 2);
        }
        if (this.params.time == "7") {
          var start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
          data.pay_start_time = this.formatTime(start, 1);
          data.pay_end_time = this.formatTime(new Date(), 2);
        }
        if (this.params.time == "30") {
          var start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
          data.pay_start_time = this.formatTime(start, 1);
          data.pay_end_time = this.formatTime(new Date(), 2);
        }
        if (this.params.time == "m") {
          data.pay_start_time = this.formatTime(new Date(), 3);
          data.pay_end_time = this.formatTime(new Date(), 2);
        }
        if (this.params.time == "y") {
          data.pay_start_time = this.formatTime(new Date(), 4);
          data.pay_end_time = this.formatTime(new Date(), 2);
        }
        if (this.params.time == "z") {
          if (this.dateValue !== null && this.dateValue.length !== 0) {
            data.pay_start_time = this.timeValue[0]
              ? this.dateValue[0] + " " + this.timeValue[0]
              : this.dateValue[0] + " 00:00:00";
            data.pay_end_time = this.timeValue[1]
              ? this.dateValue[1] + " " + this.timeValue[1]
              : this.dateValue[1] + " 23:59:59";
          }
        }
        // 未支付状态参数传创建时间create_time_s/create_time_e 已支付传pay_start_time/pay_end_time
        if (this.params.pay_status == "1") {
          data.create_time_s = data.pay_start_time;
          data.create_time_e = data.pay_end_time;
          delete data.pay_start_time;
          delete data.pay_end_time;
        }
      }
      if (!this.showAllList) {
        data.pay_status = "2";
      } else {
        data.pay_status = "1";
      }
      if (this.params.money != "") {
        data.money = this.params.money;
        data.opt = this.params.moneyType;
      }
      if (this.params.card_select.length == 2) {
        data.card_type = this.params.card_select[0];
        data.card_id = this.params.card_select[1];
      }
      if (this.uid != "") {
        data.uid = this.uid;
      }
      if (this.isvoucher == 1) {
        deleteRechargeList(data).then((res) => {
          if (res.code == 200) {
            console.log("111111");
            this.listData = res.data;
            this.statItems = Object.assign({}, res.count);
            this.listData.forEach((item) => {
              item.emp.name = item.emp.name ? item.emp.name : "买单";
              item.show_status = item.pay_status == "1" ? "未支付" : "已支付";
              item.show_payTime = item.payment_time
                ? this.mydateFormat(item.payment_time)
                : "";
              item.show_payment =
                item.payment_code == "unionpay"
                  ? "银联支付"
                  : item.payment_code == "cash"
                  ? "现金支付"
                  : item.payment_code == "allinpay"
                  ? "通联支付"
                  : item.payment_code == "normal_allinpay"
                  ? "聚合支付"
                  : item.payment_code == "lakala"
                  ? "快捷支付"
                  : item.payment_code == "leshua"
                  ? "乐 付"
                  : item.payment_code == "alipay"
                  ? "支付宝支付"
                  : item.payment_code == "wxpay"
                  ? "微信支付"
                  : item.payment_code == "fuiou"
                  ? "闪付"
                  : item.payment_code == "pos"
                  ? "刷卡"
                  : "";

              item.show_from =
                item.source == "wx"
                  ? "微信"
                  : item.source == "h5"
                  ? "支付宝"
                  : item.source == "wxapp"
                  ? "微信小程序"
                  : item.source == "aliapp"
                  ? "支付宝小程序"
                  : item.source == "pos"
                  ? "终端机"
                  : item.source == "pc"
                  ? "后台"
                  : "";
              console.log("111", item.show_payment);
            });
            this.total = res.total;
          } else if (res.code == 400) {
            this.statItems = Object.assign({}, res.count);
            if (this.uid == "") {
              this.$message(res.msg);
            }
            this.listData = [];
            this.total = 0;
          }
          this.tableLoading = false;
        });
      } else {
        voucherList(data).then((res) => {
          if (res.code == 200) {
            console.log("111111");
            this.listData = res.data;
            this.statItems = Object.assign({}, res.count);
            this.listData.forEach((item) => {
              item.emp.name = item.emp.name ? item.emp.name : "买单";
              item.show_status = item.pay_status == "1" ? "未支付" : "已支付";
              item.show_payTime = item.payment_time
                ? this.mydateFormat(item.payment_time)
                : "";
              item.show_payment =
                item.payment_code == "unionpay"
                  ? "银联支付"
                  : item.payment_code == "cash"
                  ? "现金支付"
                  : item.payment_code == "allinpay"
                  ? "通联支付"
                  : item.payment_code == "normal_allinpay"
                  ? "聚合支付"
                  : item.payment_code == "lakala"
                  ? "快捷支付"
                  : item.payment_code == "leshua"
                  ? "乐付"
                  : item.payment_code == "alipay"
                  ? "支付宝支付"
                  : item.payment_code == "wxpay"
                  ? "微信支付"
                  : item.payment_code == "fuiou"
                  ? "闪付"
                  : item.payment_code == "pos"
                  ? "刷卡"
                  : "";

              item.show_from =
                item.source == "wx"
                  ? "微信"
                  : item.source == "h5"
                  ? "支付宝"
                  : item.source == "wxapp"
                  ? "微信小程序"
                  : item.source == "aliapp"
                  ? "支付宝小程序"
                  : item.source == "pos"
                  ? "终端机"
                  : item.source == "pc"
                  ? "后台"
                  : "";
              console.log("111", item.show_payment);
            });
            this.total = res.total;
          } else if (res.code == 400) {
            this.statItems = Object.assign({}, res.count);
            if (this.uid == "") {
              this.$message(res.msg);
            }
            this.listData = [];
            this.total = 0;
          }
          this.tableLoading = false;
        });
      }
    },
    //切换tab页
    changeRadio(val) {
      this.page = 1;
      this.getData();
    },
    //跳页
    handleCurrentChange(p) {
      this.page = p;
      this.getData();
    },
    //查询时间
    setQueryTime() {
      console.log(this.dateValue);
      this.start_time = this.dateValue[0];
      this.end_time = this.dateValue[1];
    },
    search() {
      this.page = 1;
      this.getData();
    },
    //删除
    delItem(i) {
      console.log(i);
      this.$confirm("确定删除？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 传入已有优惠
          var list = this.discountList;
          list.splice(i, 1);
          var data = {
            token: this.token,
            app_id: this.app_id,
            config: [],
          };
          this.discountList.forEach((item) => {
            var rechange = {
              id: item.id,
              amount: item.amount,
              point: item.point,
              balance: item.balance,
            };
            var c = "";
            if (item.coupons.length) {
              item.coupons.forEach((n) => {
                c += n.id + ",";
              });
              rechange.coupons = c.substring(0, c.length - 1);
            }
            data.config.push(rechange);
          });
          voucherSet(data).then((res) => {
            if (res.code == 200) {
              this.$message({
                type: "success",
                message: "删除成功",
              });
              this.showAdd = false;
              this.getData();
            } else {
              this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
        })
        .catch();
    },
    //选择优惠券
    getCommod(data) {
      console.log(data);
      this.sList = data;
      this.showSelecter = false;
    },
    //删除选择的优惠券
    delTagItem(i) {
      console.log(i);
      this.sList.splice(i, 1);
    },
    closeDialog() {
      this.showAdd = false;
    },
    //选择赠送内容防止重复
    resetOptions() {
      console.log(this.giveList);
      this.typeList.forEach((item) => {
        item.disable = false;
      });
      this.giveList.forEach((item) => {
        this.typeList.forEach((options) => {
          if (options.id == item.type_id) {
            options.disable = true;
          }
        });
      });
    },
    //添加赠送内容
    addGiveItem() {
      this.giveList.push({ type_id: "", value: "" });
    },
    //删除赠送内容
    delGiveItem(i) {
      console.log(i);
      // if(this.giveList[i].type_id=='3'){
      //   this.sList = [];
      // }
      this.giveList.splice(i, 1);
      this.resetOptions();
    },
    //保存
    save() {
      var data = {
        token: this.token,
        app_id: this.app_id,
        config: [
          {
            id: 0,
            amount: this.amount,
          },
        ],
      };
      this.giveList.forEach((n) => {
        //n.type_id: 1.积分2.余额3.优惠券
        if (n.type_id == "1") {
          data.config[0].point = n.value;
        }
        if (n.type_id == "2") {
          data.config[0].balance = n.value;
        }
        if (n.type_id == "3") {
          var coupons = "";
          this.sList.forEach((item) => {
            coupons += item.id + ",";
          });
          data.config[0].coupons = coupons.substring(0, coupons.length - 1);
        }
      });
      console.log(data);
      // 传入已有优惠
      this.discountList.forEach((item) => {
        var rechange = {
          id: item.id,
          amount: item.amount,
          point: item.point,
          balance: item.balance,
        };
        var c = "";
        if (item.coupons.length) {
          item.coupons.forEach((n) => {
            c += n.id + ",";
          });
          rechange.coupons = c.substring(0, c.length - 1);
        }
        data.config.push(rechange);
      });
      voucherSet(data).then((res) => {
        if (res.code == 200) {
          this.$message({
            type: "success",
            message: "保存成功",
          });
          this.showAdd = false;
          this.getData();
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
      });
    },
    // 清空
    clearAll() {
      this.dateValue = [];
      this.params = {
        card_num: "", //会员卡号
        ordersn: "", //订单编号
        user_level_id: "", //等级id
        room_id: "", //门店id
        emp_id: "", //员工id
        from_id: "", //来源
        money: "", //金额查询
        moneyType: ">",
      };
      this.getData();
    },
    // 确认未支付订单窗口
    confirmOrderItem(ordersn, i) {
      this.confirmData = {
        ordersn: ordersn,
        type: "cash",
      };
      if (i == 1) {
        this.showConfirmOrder = true;
      } else {
        this.showCancelOrder = true;
      }
    },
    // 取消未支付订单
    cancelOrderSubmit() {
      var data = {
        app_id: this.app_id,
        ordersn: this.confirmData.ordersn,
      };
      console.log(data);
      cancelRecharge(data).then((res) => {
        if (res.code == 200) {
          this.$message.success("已取消订单");
          this.showCancelOrder = false;
          this.getData();
        } else {
          this.$message(res.msg);
        }
      });
    },
    // 确认未支付订单
    confirmOrderSubmit() {
      var data = {
        token: this.token,
        app_id: this.app_id,
        ordersn: this.confirmData.ordersn,
        payment_code: this.confirmData.type,
      };
      this.submitLoading = true;
      confirmRecharge(data).then((res) => {
        if (res.code == 200) {
          this.$message({
            type: "success",
            message: "保存成功",
          });
          this.showConfirmOrder = false;
          this.getData();
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
        this.submitLoading = false;
      });
    },
    // 时间筛选
    timeSearch(key) {
      //计算天数
      let a = new Date(this.dateValue[0]).getTime();
      let b = new Date(this.dateValue[1]).getTime();
      let c = b - a;
      console.log(Math.floor(c / 86400000));
      if (key == "search") {
        if (!this.dateValue[0]) {
          this.$message("未选择开始时间");
        } else if (!this.dateValue[1]) {
          this.$message("未选择结束时间");
        } else if (
          new Date(this.dateValue[0]).getTime() >
          new Date(this.dateValue[1]).getTime()
        ) {
          this.$message("开始时间不能大于结束时间");
        } else {
          this.getData();
        }
      }
      if (key == "export") {
        if (!this.dateValue[0]) {
          // this.$message("未选择开始时间");
          return {
            val: false,
            msg: "未选择开始时间",
          };
        } else if (!this.dateValue[1]) {
          // this.$message("未选择结束时间");
          return {
            val: false,
            msg: "未选择结束时间",
          };
        } else if (
          new Date(this.dateValue[0]).getTime() >
          new Date(this.dateValue[1]).getTime()
        ) {
          // this.$message("开始时间不能大于结束时间");
          return {
            val: false,
            msg: "开始时间不能大于结束时间",
          };
        } else if (Math.floor(c / 86400000) > 31) {
          // this.$message("开始时间与结束时间,间隔不能超过一个月");
          return {
            val: false,
            msg: "开始时间与结束时间,间隔不能超过一个月",
          };
        } else {
          // this.getData();
          return {
            val: true,
            // msg:'未选择开始时间'
          };
        }
      }
    },
    changeTime(val) {
      console.log(val);
      this.page = 1;
      if (val != "z") {
        this.getData();
      }
    },
    // 格式化时间戳
    formatDate(t) {
      var time = new Date(t);
      var y = time.getFullYear();
      var m = time.getMonth() + 1;
      var d = time.getDate();
      var h = time.getHours();
      var mm = time.getMinutes();
      m = m < 10 ? "0" + m : m;
      d = d < 10 ? "0" + d : d;
      h = h < 10 ? "0" + h : h;
      mm = mm < 10 ? "0" + mm : mm;
      return y + "-" + m + "-" + d + " " + h + ":" + mm;
    },
    formatTime(t, i) {
      //t:时间 i:格式化 1.截取到日期的00:00:00 2.截取到日期的23:59:59 3.截取到本月开始时间 4.截取到本年开始时间
      var time = this.formatDate(t);
      if (i == 1) {
        var rt = time.split(" ")[0] + " 00:00:00";
        return rt;
      } else if (i == 2) {
        var rt = time.split(" ")[0] + " 23:59:59";
        return rt;
      } else if (i == 3) {
        var rt = time.split("-")[0] + "-" + time.split("-")[1] + "-01 00:00:00";
        return rt;
      } else if (i == 4) {
        var rt = time.split("-")[0] + "-01-01 00:00:00";
        return rt;
      }
    },
    // 导出方法
    exportList() {
      if (this.params.time == "z") {
        var obj = this.timeSearch("export");
        if (obj.val) {
          var data = {
            token: this.token,
            Api: "offlinestore/agent.recharge/index",
            params: [{ name: "app_id", value: this.app_id }],
          };
          if (!this.showAllList) {
            data.params.push({
              name: "pay_status",
              value: "2",
            });
          }
          if (this.params.room_id != "") {
            data.params.push({
              name: "room_id",
              value: this.params.room_id,
            });
          }
          if (this.params.user_level_id != "") {
            data.params.push({
              name: "user_level_id",
              value: this.params.user_level_id,
            });
          }
          if (this.params.time != "0") {
            if (this.params.time == "1") {
              data.pay_start_time = this.formatTime(new Date(), 1);
              data.pay_end_time = this.formatTime(new Date(), 2);
            }
            if (this.params.time == "2") {
              var start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              data.pay_start_time = this.formatTime(start, 1);
              data.pay_end_time = this.formatTime(start, 2);
            }
            if (this.params.time == "7") {
              var start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              data.pay_start_time = this.formatTime(start, 1);
              data.pay_end_time = this.formatTime(new Date(), 2);
            }
            if (this.params.time == "30") {
              var start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              data.pay_start_time = this.formatTime(start, 1);
              data.pay_end_time = this.formatTime(new Date(), 2);
            }
            if (this.params.time == "m") {
              data.pay_start_time = this.formatTime(new Date(), 3);
              data.pay_end_time = this.formatTime(new Date(), 2);
            }
            if (this.params.time == "y") {
              data.pay_start_time = this.formatTime(new Date(), 4);
              data.pay_end_time = this.formatTime(new Date(), 2);
            }
            if (this.params.time == "z") {
              if (this.dateValue !== null && this.dateValue.length !== 0) {
                data.pay_start_time = this.timeValue[0]
                  ? this.dateValue[0] + " " + this.timeValue[0]
                  : this.dateValue[0] + " 00:00:00";
                data.pay_end_time = this.timeValue[1]
                  ? this.dateValue[1] + " " + this.timeValue[1]
                  : this.dateValue[1] + " 23:59:59";
              }
            }

            data.params.push({
              name: "pay_start_time",
              value: data.pay_start_time,
            });
            data.params.push({
              name: "pay_end_time",
              value: data.pay_end_time,
            });
          }
          console.log(data);
          exportMethod(data);
        } else {
          this.$message.error(obj.msg);
        }
      } else {
        this.$message("请选择自定义时间导出");
      }
    },
    // 点击行跳转用户详情
    rowClick(id) {
      console.log("hang");
      this.$router.push({
        path: "/apply/newVip/13/center/userDetail",
        query: { id: id },
      });
    },
    // 打印小票
    printReceipt(id) {
      this.$confirm("确定打印该订单的小票?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          rechargePrint({ id: id, app_id: this.app_id }).then((res) => {
            if (res.responseCode == 0) {
              this.$message.success(res.msg);
            } else {
              this.$message(res.msg);
            }
          });
        })
        .catch(() => {});
    },
    // 表格多选
    handleSelectionChange(val) {
      this.multipleSelection = [];
      val.forEach((item) => {
        this.multipleSelection.push(item.id);
      });
      console.log(this.multipleSelection);
    },
    // 安全設置详情
    async get_detail() {
      try {
        var data = { app_id: this.app_id };
        const res = await get_safeinfo(data);
        if (res.code == 200) {
          this.deleteForm.is_verification =
            res.data.open_sms_delete_order == 0 ? false : true;
          this.config = res.data;
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 管理员发送验证码
    async SendMyCode() {
      try {
        var data = { app_id: this.app_id };
        const res = await SendAdminCode(data);
        if (res.code == 200) {
          this.$message.success(res.msg);
        } else {
          this.$message.error(res.msg);
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getCode() {
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.SendMyCode();
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
            this.code_text = this.count + "s";
            this.btn_status = true;
          } else {
            this.btn_status = false;
            this.timer = null;
            this.code_text = "获取验证码";
          }
        }, 1000);
      }
    },
    closeBatchPopup() {
      this.batchShows = false;
      this.batchShow = false;
      this.dateValueFake = [];
      this.timeValueFake = [];
      this.deleteForm = {
        status: "", //1 为 单个删除 2，多个单订单 3， 时间批量
        id: "",
        code: "", //验证码
        is_verification: this.deleteForm.is_verification,
      };
    },
    //订单恢复
    recoverRecharge(status = "", id = "") {
      this.get_detail(); //是否需要验证码
      if (status == "1") {
        // 单个删除订单
        this.deleteForm.id = id;
        this.deleteForm.status = "1"; //单个删除
        if (!this.deleteForm.is_verification) {
          this.FakeRechangeOrder(2);
        }
      } else if (status == 2) {
        if (this.multipleSelection.length) {
          this.deleteForm.status = "2"; // 多选单个订单批量删除
          this.deleteForm.id = this.multipleSelection.join(",");
          if (!this.deleteForm.is_verification) {
            this.FakeRechangeOrder(2);
          }
        } else {
          this.$message("请选择订单记录");
          return;
        }
      } else {
        this.deleteForm.status = "3"; //时间范围的批量删除
      }
      if (this.deleteForm.is_verification || this.deleteForm.status == "3") {
        this.batchShows = true;
      }
    },
    // 批量删除
    batchDetele(status = "", id = "") {
      this.get_detail(); //是否需要验证码
      if (status == "1") {
        // 单个删除订单
        this.deleteForm.id = id;
        this.deleteForm.status = "1"; //单个删除
        if (!this.deleteForm.is_verification) {
          this.FakeRechangeOrder(1);
        }
      } else if (status == 2) {
        if (this.multipleSelection.length) {
          this.deleteForm.status = "2"; // 多选单个订单批量删除
          this.deleteForm.id = this.multipleSelection.join(",");
          if (!this.deleteForm.is_verification) {
            this.FakeRechangeOrder(1);
          }
        } else {
          this.$message("请选择订单记录");
          return;
        }
      } else {
        this.deleteForm.status = "3"; //时间范围的批量删除
      }
      if (this.deleteForm.is_verification || this.deleteForm.status == "3") {
        this.batchShow = true;
      }
    },
    // 假删除订单
    FakeRechangeOrder(key) {
      if (this.deleteForm.is_verification) {
        if (this.deleteForm.code == "") {
          this.$message.warning("请填写正确的验证码！！");
          return;
        }
      }
      if (this.deleteForm.status == "3") {
        if (
          this.dateValueFake.length !== 2 &&
          this.timeValueFake.length !== 2
        ) {
          this.$message.warning("请正确填写时间范围！！");
          return;
        }
        console.log("日期", this.dateValueFake, this.timeValueFake);
        var startD = new Date(
          Date.parse(this.dateValueFake[0].replace(/-/g, "/"))
        );
        var endD = new Date(
          Date.parse(this.timeValueFake[0].replace(/-/g, "/"))
        );
        var days = parseInt(
          (endD.getTime() - startD.getTime()) / (1000 * 60 * 60 * 24)
        );
        if (days > 30) {
          this.$message.warning("日期范围应在一个月之内！！");
          return false;
        }
      }
      if (key == 2) {
        let data = {
          app_id: this.app_id,
          verification_code: this.deleteForm.code,
        };
        if (this.deleteForm.status != 3) {
          data.id = this.deleteForm.id;
        }
        if (this.deleteForm.status == 3) {
          // data.create_time_s
          data.create_time_s = this.dateValueFake.join(",");
          data.create_time_e = this.timeValueFake.join(",");
        }
        recoverRecharge(data).then((res) => {
          if (res.code == 200) {
            this.batchShows = false;
            this.dateValueFake = [];
            this.timeValueFake = [];
            this.deleteForm = {
              status: "", //1 为 单个删除 2，多个单订单 3， 时间批量
              id: "",
              code: "", //验证码
              is_verification: this.deleteForm.is_verification,
            };
            this.getData();
            this.$message.success(res.msg);
          } else {
            this.$message(res.msg);
          }
        });
      } else {
        this.$confirm("确定要删除这些订单吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            let data = {
              app_id: this.app_id,
              verification_code: this.deleteForm.code,
            };
            if (this.deleteForm.status != 3) {
              data.id = this.deleteForm.id;
            }
            if (this.deleteForm.status == 3) {
              // data.create_time_s
              data.create_time_s = this.dateValueFake.join(",");
              data.create_time_e = this.timeValueFake.join(",");
            }
            deleteFakeRechangeOrder(data).then((res) => {
              if (res.code == 200) {
                this.batchShow = false;
                this.dateValueFake = [];
                this.timeValueFake = [];
                this.deleteForm = {
                  status: "", //1 为 单个删除 2，多个单订单 3， 时间批量
                  id: "",
                  code: "", //验证码
                  is_verification: this.deleteForm.is_verification,
                };
                this.getData();
                this.$message.success(res.msg);
              } else {
                this.$message(res.msg);
              }
            });
          })
          .catch(() => {});
      }
    },
    // 订单退款
    refundShow(row) {
      this.ordersn = row.ordersn;
      this.money = row.amount;
      this.refundIsShow = true;
    },
    closeRefund() {
      this.ordersn = "";
      this.money = "";
      this.refundIsShow = false;
      this.desc = "";
    },
    refundSubmit() {
      let data = {
        app_id: this.app_id,
        ordersn: this.ordersn,
        refund_desc: this.desc,
        verification_code: this.verification_code,
      };
      this.$confirm("确定要为此订单退款吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          var loading = this.$loading({
            lock: true,
            text: "退款中,请耐心等待...",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          refund_recharge(data).then((res) => {
            if (res.code == 200) {
              this.$message({
                type: "success",
                message: res.msg,
              });
              loading.close();
              this.desc = "";
              this.ordersn = "";
              this.money = "";
              this.verification_code = "";
              this.refundIsShow = false;
              this.getData(1);
            } else if (res.code == 202) {
              this.timer = setInterval(() => {
                this.refundStatus();
                loading.close();
              }, 1500);
            } else {
              loading.close();
              this.$message({
                type: "error",
                message: res.msg,
              });
              // this.desc = "";
              // this.ordersn = "";
              // this.money = "";
              // this.refundIsShow = false;
            }
          });
        })
        .catch(() => {});
    },
    async refundStatus() {
      try {
        let data = {
          app_id: this.app_id,
          ordersn: this.ordersn,
        };
        const res = await refund_status(data);
        if (res.code == 200) {
          switch (res.data.refund_status) {
            case 0:
              this.$message.info("未退款");
              clearInterval(this.timer);
              this.timer = null;
              this.desc = "";
              this.ordersn = "";
              this.verification_code = "";
              this.money = "";
              this.refundIsShow = false;
              break;
            case 1:
              this.$message.info("退款中,请耐心等待");
              clearInterval(this.timer);
              this.timer = null;
              this.desc = "";
              this.ordersn = "";
              this.verification_code = "";
              this.money = "";
              this.refundIsShow = false;
              break;
            case 2:
              this.$message.info("退款完成");
              clearInterval(this.timer);
              this.timer = null;
              this.desc = "";
              this.verification_code = "";
              this.ordersn = "";
              this.money = "";
              this.refundIsShow = false;
              break;
            default:
              this.$message.info("退款失败");
              clearInterval(this.timer);
              this.timer = null;
              this.verification_code = "";
              this.desc = "";
              this.ordersn = "";
              this.money = "";
              this.refundIsShow = false;
              break;
          }
        }
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  padding: 10px 15px;
  height: 100%;
  background: #f1f2f6;
  overflow: auto;
  .bodycontent {
    position: relative;
    padding: 20px;
    font-size: 14px;
    background: #fff;

    .options {
      .options_item {
        width: 270px;
        display: inline-block;
        line-height: 30px;
      }
      .options_item2 {
        display: inline-block;
        line-height: 30px;
      }
      .options_item3 {
        width: 370px;
        display: inline-block;
        line-height: 30px;
      }
      .date_picker_box {
        width: 130px;
      }
      .time_picker_box {
        width: 95px;
        margin-right: 8px;
      }
      // .options_input{
      //   width: 220px;
      // }
      // .options_input_select{
      //   width: 280px;
      // }
    }
    .dflex {
      flex: 1;
    }
    .discount_box {
      flex: 1;
      .discount_item {
        height: 40px;
        line-height: 40px;
        span {
          margin-left: 20px;
        }
      }
    }
    .level_img {
      width: 60px;
      height: 60px;
    }
    //表格中的商品内容
    .table_line {
      height: 20px;
      line-height: 20px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    //分页
    .Otherpage {
      height: 34px;
      width: 200px;
      line-height: 34px;
    }
    .btbutton {
      margin: 40px auto;
      text-align: center;
    }
    .dialogflex {
      display: flex;
      .flex_title {
        margin-bottom: 25px;
        font-weight: bold;
      }
      .item_line {
        margin-bottom: 10px;
        display: flex;
        .type {
          margin-right: 15px;
        }
        .value {
          flex: 1;
        }
        .close {
          margin-left: 10px;
        }
        .input_box_small {
          width: 140px;
        }
      }
      .line_title {
        height: 32px;
        line-height: 32px;
        display: inline-block;
      }
      .input_box_short {
        width: 140px;
        margin-left: 15px;
        vertical-align: top;
      }
      .flex_left {
        margin-right: 20px;
      }
      .flex_right {
        flex: 1;
        border-left: 1px solid #ccc;
        padding-left: 20px;
      }
      .ml10 {
        margin-left: 10px;
      }
    }
    .stat_box {
      height: 100px;
      padding: 8px 0;
      background: #f1f2f6;
      margin: 0 -20px;
      margin-bottom: 15px;
      display: flex;
      justify-content: space-between;
      .stat_item_box {
        background: #fff;
        text-align: center;
        color: #666;
        width: 18%;
        .stat_item_title {
          height: 29px;
          line-height: 29px;
          border-bottom: 1px solid #f1f2f6;
          padding-left: 10px;
        }
        .stat_item_value {
          margin: 10px 0 0 10px;
          font-size: 24px;
          span {
            font-size: 16px;
          }
        }
      }
      .stat_item_box2 {
        background: #fff;
        text-align: center;
        color: #666;
        width: 45%;
        .stat_item_title {
          height: 29px;
          line-height: 29px;
          border-bottom: 1px solid #f1f2f6;
          padding-left: 10px;
        }
        .stat_item_value2 {
          display: flex;
          div {
            flex: 1;
            .value2_title {
              margin-top: 3px;
              font-size: 14px;
            }
            .value2_value {
              margin-top: -3px;
              font-size: 24px;
              span {
                font-size: 16px;
              }
            }
          }
        }
      }
    }
  }
}
.date_picker_delete {
  width: 140px;
}
.operation-buttons {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 4px 0;
  align-items: start;
}
.operation-btn {
  text-align: center;
  min-width: 0;
}
.action-button {
  padding: 0;
  width: 100%;
  white-space: nowrap;
  color: #409eff;
}
.action-button-primary {
  color: #409eff;
}
.action-button-success {
  color: #67c23a;
}
.action-button-warning {
  color: #e6a23c;
}
.action-button-info {
  color: #909399;
}
.action-button-danger {
  color: #f56c6c;
}
</style>
